import { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../../lib/cn';

interface Props extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  glow?: boolean;
  padded?: boolean;
}

export function Card({ children, className, glow, padded = true, ...rest }: Props) {
  return (
    <div
      className={cn(
        'bg-surface border border-border rounded-2xl',
        padded && 'p-4',
        glow && 'card-glow',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
